var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{attrs:{"icon":_vm.icon,"text":"","type":_vm.type,"title":_vm.title,"outlined":"","elevation":"1"}},[_c('span',{staticClass:"letra-11"},[_vm._v(" "+_vm._s(_vm.mensaje))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }